import { render, staticRenderFns } from "./EditedBadge.vue?vue&type=template&id=88949866&scoped=true&"
import script from "./EditedBadge.vue?vue&type=script&lang=js&"
export * from "./EditedBadge.vue?vue&type=script&lang=js&"
import style0 from "./EditedBadge.vue?vue&type=style&index=0&id=88949866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88949866",
  null
  
)

export default component.exports